import React, { FunctionComponent, useState, useEffect } from 'react';
import { RecordingModel } from 'features/recordings/RecordingModel';
import paginationStyles from 'components/Pagination/styles.module.scss';
import { useMediaQuery } from 'react-responsive';
import { Card } from 'components/Card';
import ReactPaginate from 'react-paginate';
import { useSelector } from 'react-redux';
import { RootState } from 'rootReducer';
import { Loader } from 'components/Loader';
import { useSubdomain } from 'hooks/useSubdomain';
import { fetchRecordings } from 'features/recordings/recordingsSlice';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

export interface PaginatedRecordingsProps {
  recordings: RecordingModel[];
  itemsPerPage: number;
}

export const PaginatedRecordings: FunctionComponent<
  PaginatedRecordingsProps
> = ({ recordings, itemsPerPage }) => {
  const [currentItems, setCurrentItems] = useState<RecordingModel[]>([]);
  const [itemOffset, setItemOffset] = useState(0);
  const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
  const loading = useSelector((state: RootState) => state.recordings.isLoading);
  const pageCount = useSelector(
    (state: RootState) => state.recordings.pageCount
  );
  const subdomain = useSubdomain();
  const dispatch = useDispatch();

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    console.log(`Loading recordings from ${itemOffset} to ${endOffset}`);
    setCurrentItems(recordings.slice(itemOffset, endOffset));
  }, [itemOffset, itemsPerPage, recordings]);

  const handlePageClick = (event: { selected: number }) => {
    dispatch(fetchRecordings(subdomain, event.selected + 1));
    const newOffset = event.selected * itemsPerPage;
    setItemOffset(newOffset);
    window.scrollTo(0, 0);
  };

  return (
    <div className="container--wide">
      <h1>Recordings</h1>
      {recordings.length > 0 && (
        <ul className="list--reset grid">
          {currentItems.map((recording) => (
            <li className="col-xss-12 col-xs-6" key={recording.id}>
              <Card
                id={recording.id}
                url={`/recordings/${recording.id}`}
                title={`${recording.title}`}
                artworkKey={recording.artworkKey}
                artworkMode={'recording'}
                type={'recording'}
              />
            </li>
          ))}
        </ul>
      )}
      {pageCount > 1 && (
        <ReactPaginate
          containerClassName={classNames(paginationStyles['pagination'], {
            [paginationStyles['pagination--loading']]: loading
          })}
          pageClassName={paginationStyles['pagination__page']}
          pageLinkClassName={paginationStyles['pagination__link']}
          activeLinkClassName={paginationStyles['pagination__link--active']}
          previousLinkClassName={paginationStyles['pagination__link--prev']}
          nextLinkClassName={paginationStyles['pagination__link--next']}
          disabledLinkClassName={paginationStyles['pagination__link--disabled']}
          breakLabel="..."
          nextLabel="next ›"
          onPageChange={handlePageClick}
          marginPagesDisplayed={1}
          pageRangeDisplayed={isMobile ? 2 : 5}
          pageCount={pageCount}
          previousLabel="‹ prev"
          renderOnZeroPageCount={() => null}
        />
      )}
      {loading && <Loader fillComponent={true} />}
    </div>
  );
};
